<template>
  <b-col cols="10" offset-md="2">
    <b-row class="justify-content-center">
      <b-card title="Lista de clientes y bases" class="w-100">

        <b-form id="formID" @submit.prevent="fetchClients" ref="formID" class="form-row">
          <b-form-group class="col-3">
            <label for="globalsearching">Nombre tecnico o descripcion</label>
            <b-form-input type="text" placeholder="Buscar por nombre o descripción..." aria-label="buscar" id="globalsearching" v-model="searching" size="sm"></b-form-input>
          </b-form-group>

          <!-- <b-form-group class="col-2">
            <label for="alta-date">Bloqueada desde:</label>
            <b-form-datepicker id="alta-date" v-model="fecha_bloqueo_desde" class="mb-2" placeholder="Desde..." size="sm"></b-form-datepicker>
          </b-form-group> -->

         
          <b-form-group
          label-align-sm="left"
          label-size="sm"
          class="d-flex flex-wrap d-flex justify-content-between"
          v-slot="{ ariaDescribedby }"
          >
            <label for="estado">Estado:</label>
            <b-form-checkbox-group
              :aria-describedby="ariaDescribedby"
              class=""
              id="estado"
            >
              <b-form-checkbox v-model="puerto" value="3306,33061" size="sm">Habilitada</b-form-checkbox>
              <b-form-checkbox v-model="puerto" value="33060" size="sm" id="bloqueada">Bloqueada</b-form-checkbox>
              <b-form-checkbox v-model="puerto" value="8000" size="sm">Local</b-form-checkbox>
              <b-form-checkbox v-model="puerto" value="9000" size="sm">Baja</b-form-checkbox>
            
            </b-form-checkbox-group>

          </b-form-group>

           <b-form-group  class="col-2">
            <label for="bloqueo-date">Bloqueada hasta:</label>
            <b-form-datepicker reset-button id="bloqueo-date" v-model="fecha_bloqueo_hasta" class="mb-2" placeholder="Hasta..." size="sm"></b-form-datepicker>
          </b-form-group>


          <b-form-group
          label-align-sm="left"
          label-size="sm"
          class="mb-0 col-2"
          v-slot="{ ariaDescribedby }"
          >
            <label for="modolectura">Solo Lectura:</label>
            <b-form-checkbox-group
              :aria-describedby="ariaDescribedby"
              class="mt-1"
              id="modolectura"
            >
              <b-form-checkbox v-model="habilita_db_solo_lectura" value="1" unchecked-value="" size="sm">Si</b-form-checkbox>
              <b-form-checkbox v-model="habilita_db_solo_lectura" value="0" unchecked-value="" size="sm">No</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>
          
          <div class="w-100"></div>

          <b-form-group class="col-1">
            <b-button type="submit" size="sm" variant="outline-primary">Enviar</b-button>
          </b-form-group>

        </b-form>

        <br>
        
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          size="sm"
          align="fill"
          limit=20
        ></b-pagination>

        <b-table 
        id="my-table" 
        striped hover 
        :items="bases_list" 
        :fields="fields" 
        :tbody-tr-class="rowClass" 
        :busy="tableBusy" 
        :small="small" 

        :per-page="perPage" 
        :current-page="currentPage"
        >
          <template v-slot:cell(action)="row">
            <div class="row d-flex">
              <b-button size="sm" @click="row.toggleDetails" class="mr-2">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar'}} Detalles </b-button>
              <b-button size="sm" variant="success" @click="confirmHabilitar(row.item)" v-if="btnHabilitarStatus(row.item)" title="Habilitar"> <b-icon icon="unlock-fill"></b-icon></b-button>
              <b-button size="sm" variant="secondary" @click="confirmLectura(row.item)" v-if="btnLecturaStatus(row.item)" title="Solo Lectura"> <b-icon icon="eye-fill"></b-icon></b-button>
              <b-button size="sm" variant="warning" @click="confirmBloqueo(row.item)" v-if="btnBloquearStatus(row.item)" title="Bloquear"> <b-icon icon="lock-fill"></b-icon></b-button>
              <b-button size="sm" variant="danger" @click="confirmDelete(row.item)" v-if="btnBajarStatus(row.item)" title="Dar de baja"> <b-icon icon="trash-fill"></b-icon></b-button>
            </div>
          </template>

          <template #row-details="row">
            <b-card
              header="Detalles"
            >
              <b-form :id="row.item.schema_name" @submit.prevent="onSubmitUpdateDetails(row.item)" method="POST" class="form-row needs-validation" ref="formDatabaseEdit">
                
                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-fecha-alta">Fecha de alta:</label>
                  <b-form-input name="edit-fecha-alta" :value="row.item.fecha_creacion || 'Fecha no especificada'" disable></b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-fecha-liberacion">Fecha de liberacion:</label>
                  <b-form-input name="edit-fecha-liberacion" :value="row.item.fecha_liberacion || 'Fecha no especificada'">row</b-form-input>
                </b-form-group>


                  
                  <!-- Si el puerto es 3306 o 33061, mostrar la fecha del último login -->
                  <b-form-group v-if="row.item.puerto === '3306' || row.item.puerto === '33061'" class="col-md-4 col-sm-6" >
                    <label for="edit-fecha-ultimo-login">Fecha de Último Login:</label>
                    <b-form-input
                      name="edit-fecha-ultimo-login"
                      :value="formatFecha(row.item.ultimo_login_fecha)"
                      disabled
                    ></b-form-input>
                  </b-form-group>
                
                  <!-- Si el puerto es 9000, mostrar la fecha de baja -->
                  <b-form-group v-else-if="row.item.puerto === '9000'" class="col-md-4 col-sm-6">
                    <label for="edit-fecha-baja">Fecha de Baja:</label>
                    <b-form-input name="edit-fecha-baja" :value="row.item.fecha_baja || 'Fecha no especificada'"></b-form-input>
                  </b-form-group>
                
                  <!-- Si el puerto es 33060 o 330610, mostrar la fecha de bloqueo -->
                  <b-form-group v-else-if="row.item.puerto === '33060' || row.item.puerto === '330610'" class="col-md-4 col-sm-6">
                    <label for="edit-fecha-bloqueo">Fecha de Bloqueo:</label>
                    <b-form-input name="edit-fecha-bloqueo" :value="row.item.fecha_bloqueo || 'Fecha no especificada'"></b-form-input>
                  </b-form-group>


                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-nombre">Nombre-Grupo:</label>
                  <b-form-input name="edit-nombre" :value="row.item.nombre"></b-form-input>
                </b-form-group>
                
                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-razonsocial">Razon Social</label>
                  <b-form-input name="edit-razonsocial" :value="row.item.descrip_empresa"></b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-descripcion">Descripcion</label>
                  <b-form-input name="edit-descripcion" :value="row.item.descripcion"></b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-zona-list">Zona</label>
                  <b-form-input list="edit-zona-list" name="edit-zona-list" :value="row.item.zona"></b-form-input>
                  <b-form-datalist id="edit-zona-list" name="edit-zona-list" :options="zonas"></b-form-datalist>
                  <!-- <b-form-input id="edit-zona" :value="row.item.zona"></b-form-input> -->
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-zona-list">Cod Cliente</label>
                  <b-form-input list="edit-cod-cliente" name="edit-cod-cliente" :value="row.item.cod_cliente"></b-form-input>
                </b-form-group>

                <div class="w-100"></div>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-servidor">Servidor Host</label>
                  <b-form-input name="edit-servidor" :value="row.item.server1"></b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-puerto">Puerto</label>
                  <b-form-input name="edit-puerto" :value="row.item.puerto"></b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-sistema">Sistema</label>
                  <b-form-input name="edit-sistema" :value="row.item.sistema"></b-form-input>
                </b-form-group>

                <!-- <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-aplicacion-tipos-id">Tipo Aplicacion</label>
                  <b-form-input name="edit--aplicacion-tipos-id" :value="row.item.aplicacion_tipos_id"></b-form-input>
                </b-form-group> -->

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="edit-aplicacion-tipos-id">Tipo aplicacion</label>
                  <b-form-select name="edit-aplicacion-tipos-id" :value="row.item.aplicacion_tipos_id" :options="aplicacion_tipos"></b-form-select>
                </b-form-group>

                <div class="w-100"></div>


                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-campo"
                    v-if="row.item.habilita_campo == 'S'"
                    checked="true"
                  >
                    Modulo Campo
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-campo"
                    v-else
                    checked="false"
                  >
                    Modulo Campo
                  </b-form-checkbox>

                  
                </b-form-group>

                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-contabilidad"
                    v-if="row.item.habilita_contabilidad == 'S'"
                    checked="true"
                  >
                    Modulo Contabilidad
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-contabilidad"
                    v-else
                    checked="false"
                  >
                    Modulo Contabilidad
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-construccion"
                    v-if="row.item.habilita_construccion == 'S'"
                    checked="true"
                  >
                    Modulo Construccion
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-construccion"
                    v-else
                    checked="false"
                  >
                    Modulo Construccion
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-sueldos"
                    v-if="row.item.habilita_sueldo == 1"
                    checked="true"
                  >
                    Modulo Sueldos
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-sueldos"
                    v-else
                    checked="false"
                  >
                    Modulo Sueldos
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-mobile"
                    v-if="row.item.habilita_mobile == 1"
                    checked="true"
                  >
                    Synagro Mobile
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-mobile"
                    v-else
                    checked="false"
                  >
                    Synagro Mobile
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-ctg"
                    v-if="row.item.habilita_ctg == 1"
                    checked="true"
                  >
                    CTG Habilitado
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-ctg"
                    v-else
                    checked="false"
                  >
                    CTG Habilitado
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                label-align-sm="left"
                label-size="sm"
                class="col-md-4 col-sm-6"
                >
                  <b-form-checkbox
                    name="edit-habilita-synagro7"
                    v-if="row.item.habilita_synagro7 == 1"
                    checked="true"
                  >
                    Habilita Synagro 7
                  </b-form-checkbox>

                  <b-form-checkbox
                    name="edit-habilita-synagro7"
                    v-else
                    checked="false"
                  >
                    Habilita Synagro 7
                  </b-form-checkbox>
                </b-form-group>

                <div class="w-100"></div>

                <h5>Evento</h5>

                <div class="w-100"></div>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="solicitante">Solicitante</label>
                  <b-form-input id="solicitante" v-model="model.solicitante" placeholder="Ingresa nombre del solicitante" required></b-form-input>
                </b-form-group>

                <b-form-group class="col-md-4 col-sm-6">
                  <label for="evento_descrip">Motivo</label>
                  <b-form-input id="evento_descrip" v-model="model.evento_descrip" placeholder="Ingresa descripcion de modificacion" required></b-form-input>
                </b-form-group>
                <div class="w-100"></div>
                <b-form-group
                label-align-sm="right"
                label-size="sm"
                class="col-12"
                >
                  <b-button type="submit" size="lg" variant="outline-primary">Actualizar</b-button>
                </b-form-group>
              </b-form>             
            </b-card>
          </template>

          <template #table-busy>
            <div class="text-center text-secondary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> Loading...</strong>
            </div>
          </template>
        </b-table>

        <b-overlay :show="ConfirmBaja" no-wrap opacity=0.95 class="d-flex align-content-start">
          <template #overlay>
            <div
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="text-center p-3"
            >
              <p><strong >Esta accion dara de baja la base {{current_database}} en la central y se eliminara fisicamente. Estas seguro de continuar?</strong></p>
              
              <b-form-group class="">
                <label for="solicitante">Solicitante</label>
                <b-form-input type="text" placeholder="Solicitante" aria-label="solicitante" id="solicitante" v-model="solicitante" size="sm"></b-form-input>
              </b-form-group>

              <b-form-group class="">
                <label for="evento_descrip" class="text-left">Motivo</label>
                <b-form-input type="text" placeholder="Motivo" aria-label="evento_descrip" id="evento_descrip" v-model="evento_descrip" size="sm"></b-form-input>
              </b-form-group>

                <b-button variant="secondary" class="mr-3" @click="onCancel">
                  Cancelar
                </b-button>
                <b-button variant="danger" @click="deleteDatabase()">Si, dar de baja</b-button>
              </div>
          </template>
        </b-overlay>

        <b-overlay :show="ConfirmBloqueo" no-wrap opacity=0.95 class="d-flex align-content-start">
            <template #overlay>
              <div
                ref="dialog"
                tabindex="-1"
                role="dialog"
                aria-modal="false"
                aria-labelledby="form-confirm-label"
                class="text-center p-3"
              >
                <p><strong >Esta accion bloqueara la base {{current_database}} en la central y no se podra acceder. Estas seguro de continuar?</strong></p>
                
                <b-form-group class="">
                  <label for="solicitante">Solicitante</label>
                  <b-form-input type="text" placeholder="Solicitante" aria-label="solicitante" id="solicitante" v-model="solicitante" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group class="">
                  <label for="evento_descrip" class="text-left">Motivo</label>
                  <b-form-input type="text" placeholder="Motivo" aria-label="evento_descrip" id="evento_descrip" v-model="evento_descrip" size="sm"></b-form-input>
                </b-form-group>
              
                <div class="d-flex justify-content-center">
                  <b-button variant="secondary" class="mr-3" @click="onCancel">
                    Cancelar
                  </b-button>
                  <b-button variant="warning" @click="lockDatabase()">Si, bloquear</b-button>
                </div>
              </div>
            </template>
        </b-overlay>

        <b-overlay :show="ConfirmLectura" no-wrap opacity=0.95 class="d-flex align-content-start">
            <template #overlay>
              <div
                ref="dialog"
                tabindex="-1"
                role="dialog"
                aria-modal="false"
                aria-labelledby="form-confirm-label"
                class="text-center p-3"
              >
                <p><strong >Esta accion activara solo lectura en la base {{current_database}}. Estas seguro de continuar?</strong></p>
                
                <b-form-group class="">
                  <label for="solicitante">Solicitante</label>
                  <b-form-input type="text" placeholder="Solicitante" aria-label="solicitante" id="solicitante" v-model="solicitante" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group class="">
                  <label for="evento_descrip" class="text-left">Motivo</label>
                  <b-form-input type="text" placeholder="Motivo" aria-label="evento_descrip" id="evento_descrip" v-model="evento_descrip" size="sm"></b-form-input>
                </b-form-group>
              
                <div class="d-flex justify-content-center">
                  <b-button variant="secondary" class="mr-3" @click="onCancel">
                    Cancelar
                  </b-button>
                  <b-button variant="warning" @click="onlyReadDatabase()">Si, activar modo lectura</b-button>
                </div>
              </div>
            </template>
        </b-overlay>

        <b-overlay :show="ConfirmHabilitar" no-wrap opacity=0.95 class="d-flex align-content-start">
            <template #overlay>
              <div
                ref="dialog"
                tabindex="-1"
                role="dialog"
                aria-modal="false"
                aria-labelledby="form-confirm-label"
                class="text-center p-3"
              >
                <p><strong >Esta accion habilitara la base {{current_database}}. Estas seguro de continuar?</strong></p>
                
                <b-form-group class="">
                  <label for="solicitante">Solicitante</label>
                  <b-form-input type="text" placeholder="Solicitante" aria-label="solicitante" id="solicitante" v-model="solicitante" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group class="">
                  <label for="evento_descrip" class="text-left">Motivo</label>
                  <b-form-input type="text" placeholder="Motivo" aria-label="evento_descrip" id="evento_descrip" v-model="evento_descrip" size="sm"></b-form-input>
                </b-form-group>
              
                <div class="d-flex justify-content-center">
                  <b-button variant="secondary" class="mr-3" @click="onCancel">
                    Cancelar
                  </b-button>
                  <b-button variant="success" @click="enableDatabase()">Si, habilitar</b-button>
                </div>
              </div>
            </template>
        </b-overlay>


      </b-card>
    </b-row>
  </b-col>

</template>

<script>
import _ from 'lodash';
import {TokenService} from "./../storage/service"
import feather from "feather-icons"

export default {
  name: 'ClientsList',
  props: {
    msg: String
  },
  data: function () {
    return {
      bases_list: [],
      zonas: [],
      aplicacion_tipos: [],
      perPage: 15,
      currentPage: 1,
      puerto: [],
      habilita_db_solo_lectura: "",
      searching : "",
      fecha_bloqueo_hasta: "",
      fecha_bloqueo_desde: "",
      alta_date: "",
      tableBusy: false,
      ConfirmBaja: false,
      ConfirmBloqueo: false,
      ConfirmLectura: false,
      ConfirmHabilitar: false,
      small: true,
      fields: [
        // {key: 'descrip_empresa', label: 'Razon Social'},
        {key: 'descripcion', label:'Descripcion'},
        {key: 'schema_name', label:'Nombre Tecnico'},
        {key: 'server1', label:'Servidor'},
        // {key: 'puerto', label:'puerto'},
        // {key: 'habilita_contabilidad'},
        {key: 'action', label:'Accion'}
      ],
      current_database: "",
      current_port: "",
      current_descripcion: "", 
      current_server1: "",
      model: {
        // server1: "",
        // num_server: this.server1,
        srv_app_updt: 'synagro0.dnsalias.com',
        habilita_tesoreria: 1,
        fecha_liberacion: "",
        // schema_name: "",
        habilita_db_solo_lectura: 0,
        empresa: "TS",
      },
      response: {}
    };
  },
  created: function () {
    // _.debounce is a function provided by lodash to limit how
    // often a particularly expensive operation can be run.
    // In this case, we want to limit how often we access
    // yesno.wtf/api, waiting until the user has completely
    // finished typing before making the ajax request. To learn
    // more about the _.debounce function (and its cousin
    // _.throttle), visit: https://lodash.com/docs#debounce
    this.debouncedGetDatabases = _.debounce(this.fetchClients, 700)
  },
  mounted() {
    this.login();
    this.fetchClients("", this.$globalsearching);
    this.fetchDbZonas();
    this.fetchAplicacionTipos();
    feather.replace();
  },
  methods: {
    formatFecha(fechaIso) {
    if (!fechaIso) return 'Fecha no especificada';
    const fecha = new Date(fechaIso);
    return fecha.toLocaleString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  },
    login(){
      let token = TokenService.getToken()
      this.$http.post(this.backendURL + 'api/v1.0/checkSession/', {headers: {'Authorization': 'Token ' + token}})
      .then(() => {
        console.log("Token Correcto")
      })
      .catch(err => {
        // catch error});
        if(err.request.statusText == 'Unauthorized'){
          alert("Su sesion ha expirado...")
          this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/login')
          })
        }
        else {
          console.log(err.data)
        }
      })
    },
    onCancel() {
      this.ConfirmBaja = false
      this.ConfirmBloqueo = false
      this.ConfirmLectura = false
      this.ConfirmHabilitar = false
    },
    toggleBusy() {
      this.tableBusy = !this.tableBusy
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return
      else if ((item.puerto == '3306' || item.puerto == '33061') && item.habilita_db_solo_lectura == '0') return 'table-success'
      else if (item.puerto === '9000' || item.puerto === '8000') return 'table-danger'
      else if (item.puerto === '33060') return 'table-warning'
      if (item.habilita_db_solo_lectura === 1) return 'table-secondary'
    },
    btnHabilitarStatus(item){
      if(item.puerto == 33060 || item.habilita_db_solo_lectura == 1) return true
      else return false
    },
    btnBloquearStatus(item){
      if(item.puerto == 3306 || item.puerto == 33061) return true
      else return false
    },
    btnLecturaStatus(item){
      if(item.habilita_db_solo_lectura == 0 && item.puerto != 9000 && item.puerto != 8000) return true
      else return false
    },
    btnBajarStatus(item){
      if(item.puerto != 9000 && item.puerto != 8000) return true
      else return false
    },
    fetchClients() {
      this.toggleBusy()
      
      // Eliminamos el parámetro schema_name de la URL para obtener todos los registros
      let url = this.backendURL + 'api/v1.0/Empresa/?puerto='+this.puerto+'&habilita_db_solo_lectura='+this.habilita_db_solo_lectura+'&fecha_bloqueo_hasta='+this.fecha_bloqueo_hasta;
      this.$http.get(url)
      .then( result => {
        // Si hay un término de búsqueda, filtramos también por descripción en el frontend
        if (this.searching && this.searching.trim() !== '') {
          const searchTerm = this.searching.toLowerCase().trim();
          
          // Filtramos por schema_name o descripcion, con manejo seguro de valores nulos/undefined
          this.bases_list = result.data.filter(item => {
            const schemaMatch = item.schema_name && item.schema_name.toString().toLowerCase().includes(searchTerm);
            const descMatch = item.descripcion && typeof item.descripcion === 'string' && item.descripcion.toLowerCase().includes(searchTerm);
            
            // Para depuración
            console.log('Item:', item.schema_name, 'Descripción:', item.descripcion);
            console.log('Matches:', schemaMatch, descMatch);
            
            return schemaMatch || descMatch;
          });
        } else {
          this.bases_list = result.data;
        }
        this.toggleBusy()
      })
    },

    fetchDbZonas(){
      let url = this.backendURL + 'api/v1.0/ZonasEmpresas/';
      this.$http.get(url)
      .then( result => {
        console.log(result.data)
        for(var i in result.data){
          this.zonas.push(result.data[i].zona)
        }
      })
    },
    fetchAplicacionTipos() {
      let url = this.backendURL + 'api/v1.0/AplicacionTipos/';
      this.$http.get(url)
      .then( result => {
        console.log(result.data)
        for(var i in result.data){
          this.aplicacion_tipos.push({value: result.data[i].aplicacion_tipos_id, text: result.data[i].aplicacion_tipo})
        }
      })
    },

    lockDatabase() {
      let url = this.backendURL + 'api/v1.0/bloqueo_base/';
      this.$http.post(url, {schema_name: this.current_database, puerto: this.current_port, descripcion: this.current_descripcion, server_host: this.current_server1, evento_descrip: this.evento_descrip, solicitante: this.solicitante})
      .then( result => {
        alert(result.data.msg)
        this.ConfirmBloqueo = false
        this.fetchClients()
      })
    },
    onlyReadDatabase() {
      let url = this.backendURL + 'api/v1.0/solo_lectura_base/';
      this.$http.post(url, {schema_name: this.current_database, evento_descrip: this.evento_descrip, solicitante: this.solicitante})
      .then( result => {
        alert(result.data.msg)
        this.ConfirmLectura = false
        this.fetchClients()
      })
    },
    enableDatabase() {
      let url = this.backendURL + 'api/v1.0/habilitar_base/';
      this.$http.post(url, {schema_name: this.current_database, evento_descrip: this.evento_descrip, solicitante: this.solicitante})
      .then( result => {
        alert(result.data.msg)
        this.ConfirmHabilitar = false
        this.fetchClients()
      })
    },

    confirmDelete(item){
      this.ConfirmBaja = true
      this.current_database = item.schema_name
    },

    confirmBloqueo(item){
      this.ConfirmBloqueo = true
      this.current_database = item.schema_name
      this.current_port = item.puerto
      this.current_descripcion = item.descripcion
      this.current_server1 = item.server1
    },

    confirmLectura(item){
      this.ConfirmLectura = true
      this.current_database = item.schema_name
      this.current_port = item.puerto
      this.current_descripcion = item.descripcion
      this.current_server1 = item.server1
    },

    confirmHabilitar(item){
      this.ConfirmHabilitar = true
      this.current_database = item.schema_name
      this.current_port = item.puerto
      this.current_descripcion = item.descripcion
      this.current_server1 = item.server1
    },

    deleteDatabase() {
      let url = this.backendURL + 'api/v1.0/baja_base/';
      this.$http.post(url, {schema_name: this.current_database, solicitante: this.solicitante, evento_descrip: this.evento_descrip})
      .then( result => {
        alert(result.data.msg)
        this.fetchClients()
        this.ConfirmBaja = false
      })
    },

    onSubmitUpdateDetails(database_data) {
      // alert("Update empresa");
      // var arrayEmpresa = $(this).serializeArray();
      var schemaForm = document.getElementById(database_data.schema_name);
      this.model.schema_name = database_data.schema_name;
      this.model.fecha_creacion = schemaForm.elements["edit-fecha-alta"].value;
      //this.model.fecha_liberacion = schemaForm.elements["edit-fecha-liberacion"].value;
      // Obtener el valor de la fecha desde el formulario
      let fechaLiberacion = schemaForm.elements["edit-fecha-liberacion"].value;
          
      // Comprobar si el valor es "Fecha no especificada" y asignar una cadena vacía si es el caso
      if (fechaLiberacion === "Fecha no especificada") {
          this.model.fecha_liberacion = "";
      } else {
          // De lo contrario, asignar el valor normal
          this.model.fecha_liberacion = fechaLiberacion;
      }
      this.model.fecha_bloqueo = database_data.fecha_bloqueo;
      this.model.nombre = schemaForm.elements["edit-nombre"].value;
      this.model.descrip_empresa = schemaForm.elements["edit-razonsocial"].value;
      this.model.descripcion = schemaForm.elements["edit-descripcion"].value;
      this.model.zona = schemaForm.elements["edit-zona-list"].value;
      this.model.server1 = schemaForm.elements["edit-servidor"].value;
      this.model.server7 = schemaForm.elements["edit-servidor"].value;
      this.model.server6 = schemaForm.elements["edit-servidor"].value;
      this.model.server5 = schemaForm.elements["edit-servidor"].value;
      this.model.server4 = schemaForm.elements["edit-servidor"].value;
      this.model.server3 = schemaForm.elements["edit-servidor"].value;
      this.model.server2 = schemaForm.elements["edit-servidor"].value;
      this.model.server1_central = schemaForm.elements["edit-servidor"].value;
      this.model.server1_central = schemaForm.elements["edit-servidor"].value;
      this.model.num_server = database_data.num_server;
      this.model.version = database_data.version;
      this.model.baja = database_data.baja;
      this.model.baja = database_data.base_bloqueada;
      this.model.db_tipo_id = database_data.db_tipo_id;
      this.model.puerto = schemaForm.elements["edit-puerto"].value;
      this.model.sistema = schemaForm.elements["edit-sistema"].value;
      this.model.aplicacion_tipos = schemaForm.elements["edit-aplicacion-tipos-id"].value;
      this.model.habilita_campo = schemaForm.elements["edit-habilita-campo"].checked  ? 'S' : 'N';
      this.model.habilita_contabilidad = schemaForm.elements["edit-habilita-contabilidad"].checked ? 'S' : 'N';
      this.model.habilita_construccion = schemaForm.elements["edit-habilita-construccion"].checked ? 'S' : 'N';
      this.model.habilita_sueldo = schemaForm.elements["edit-habilita-sueldos"].checked ? 1 : 0;
      this.model.habilita_ctg = schemaForm.elements["edit-habilita-ctg"].checked ? 1 : 0;
      this.model.habilita_synagro7 = schemaForm.elements["edit-habilita-synagro7"].checked ? 1 : 0;
      this.model.habilita_mobile = schemaForm.elements["edit-habilita-mobile"].checked ? 1 : 0;
      this.model.cod_cliente = schemaForm.elements["edit-cod-cliente"].value;
      
      console.log("Datos viejos: "); console.log(database_data);
      console.log("Datos Nuevos: "); console.log(this.model);
      // alert("Anterior: " + database_data.aplicacion_tipos_id + " Nuevo: " + new_aplicacion_tipo);
      // envia el post
      this.toggleBusy();
      this.$http.post(this.backendURL + 'api/v1.0/editar_base/', this.model, {timeout: 360000})
      .then(res => {
          // do something with res
          
          console.log(res.data);
          this.response = res.data
          if(this.response.msg.includes("ok")){
            // this.showOkAlta = true
            alert("Se actualizo correctamente la base de datos!");
            this.toggleBusy();
            this.fetchClients();
          }
          else {
            // this.showErrorAlta = true;
            alert("Error al actualizar base de datos: " + this.response.msg);
            this.toggleBusy();
            this.fetchClients();
          }
      })
      .catch(err => {
          // catch error});
          console.log(err.data)
          this.response = err.data;
      })
      // this.fetchClients()
    }
  },

  watch: {
    searching(){
      console.log(this.searching, this.puerto)
      this.debouncedGetDatabases()
    }
  },

  computed: {
    rows() {
      return this.bases_list.length
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 25px 0 0;
}
button {
  margin: 0 5px;
}

.vue-form-generator .field-switch input:checked~.label{
  background: #2f9401;
}

</style>
